import { render } from "./CardAdmin.vue?vue&type=template&id=3bd58125"
import script from "./CardAdmin.vue?vue&type=script&lang=js"
export * from "./CardAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__